import { createActions, } from 'redux-actions';

export default createActions({
  SPLIT_HAND: {
    REQUEST: null,
    SEND: null,
  },
});
